import React from "react";
import "./Businessbrand.css";

// Pending Images Upload

function Businessbrand(){

    return(
        <div className="contents">
  <div className="container">
  {/* <!-- Row 1: Three Cards --> */}
  <div className="row justify-content-center g-4">
    <div className="col-md-4">
      <div className="cardid card border border-dark">

                      <div className="corner-circle"></div>

        <div className="card-body">
          <h5 className="card-title">
              <img src="socialmedia.png" alt="Logo"/>
       Content Planning & Strategy</h5>
          <p className="card-text">We create a customized content calendar based on your brand goals, audience behavior, and current trends. From festivals to product promotions, we plan every post to build engagement and maintain consistency across all social platforms.</p>
        </div>
      </div>
    </div>
    <div className="col-md-4">
      <div className=" cardid card  border border-dark">

                      <div className="corner-circle "></div>

        <div className="card-body">
         <h5 className="card-title">
        <img src="searchengine.png" alt="Logo"/>
          Post Design & Creative Content</h5>
          <p className="card-text">
      We design eye-catching visuals, reels, carousels, and story templates that reflect your brand identity. Whether it's an announcement or a viral trend, our creative content is tailored to boost attention and interaction.</p>
        </div>
      </div>
    </div>
    <div className="col-md-4">
      <div className="cardid card  border border-dark">

                              <div className="corner-circle "></div>

        <div className="card-body">
          <h5 className="card-title">
          <img src="Google.png" alt="Logo"/>
       Account Management & Optimization</h5>
          <p className="card-text">We manage your social profiles professionally—updating bios, maintaining highlights, responding to messages, and optimizing every part of your page to make your brand look trustworthy and active.</p>
        </div>
      </div>
    </div>
  </div>

  <div className="row justify-content-center g-4 mt-3">
    <div className="col-md-4">
      <div className="cardid card  border border-dark">

                              <div className="corner-circle "></div>

        <div className="card-body">
          <h5 className="card-title">
          <img src="content.png" alt="Logo"/>
         Audience Engagement & Community Building</h5>
          <p className="card-text">We help you build a loyal online community by actively engaging with followers through comments, replies, polls, and stories. Our approach ensures your audience feels valued and stays connected with your brand.</p>
        </div>
      </div>
    </div>
    <div className="col-md-4">
      <div className="cardid card  border border-dark">

                              <div className="corner-circle "></div>

        <div className="card-body">
          <h5 className="card-title">
          <img src="email.png" alt="Logo"/>
      Performance Tracking & Monthly Reports</h5>
          <p className="card-text">We track every campaign and post’s performance using insights and analytics. You receive detailed monthly reports showing growth, engagement rates, reach, and suggestions for improvement to keep scaling results.</p>
        </div>
      </div>
    </div>
  </div>
</div>


<button type="button" className="exitbutton btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
  Move to Previous
</button>


<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Exit page</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
      Are You Really want to Exit this page..
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">No</button>
        <button type="button" class="btn btn-primary">Yes</button>
      </div>
    </div>
  </div>
</div>


        </div>
    )

}
export default Businessbrand;